import { clearLocal } from "@/helpers/localStore";
import { reloadOtherTabs } from "@/shared/helpers/authHelper";
import { persistor } from "@/config/store";
import { authConstants } from "@/config/constants";

export const logoutAction = () => (dispatch) => {
  clearLocal();
  persistor && persistor.purge();
  reloadOtherTabs();
  dispatch({ type: authConstants.LOGOUT });
};
